import React from "react";
//import PropTypes from 'prop-types';

import CategoriesTree from "playground/cms/views/Categories/CategoriesTree";

export function CategorySelect(props) {
    const { onChange, value } = props;
    return (
        <div style={{ width: "320px", height: "400px" }}>
            <CategoriesTree onSelect={onChange} selected={value} />
        </div>
    );
}

CategorySelect.propTypes = {};

CategorySelect.defaultProps = {};

export default CategorySelect;
